import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=5425c8f3&"
var script = {}
import style0 from "./LeftSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports